<template>
  <div class="img_box">
    <!-- 中文 -->
    <img src="../../static/kefon_logo.png" alt="">
    <!-- 英文 -->
    <!-- <img src="../../static/kefon_logo_en.png" alt=""> -->
  </div>
</template>

<script>
  export default {
    name: 'Header',
    props: [''],
    data() {
      return {
      }
    },
    components: {},

    computed: {},

    mounted() {},

    methods: {}

  }

</script>
<style lang='' scoped>
  .img_box img{
    width:300px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Header.vue